import { styled } from '@/styled-system/jsx';

export const StreetViewErrorContainer = styled('div', {
  base: {
    backgroundColor: 'hpxWhite',
    borderRadius: '4px',
  },
});
